/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect } from 'react';
import { generatePath, Redirect, useLocation, useParams } from 'react-router-dom';
import { getKnowledgeBase } from '../../knowledge-base/actions/KnowledgeBaseActions';
import { selectKnowledgeBase, selectKnowledgeBasesFetched, selectKnowledgeBasesNotFetched } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
const RedirectToDefaultKnowledgeBase = ({
  from,
  to
}) => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const {
    search
  } = useLocation();
  const needsToFetchKnowledgeBase = useAppSelector(selectKnowledgeBasesNotFetched);
  const hasFetchedKnowledgeBases = useAppSelector(selectKnowledgeBasesFetched);
  const defaultKnowledgeBaseId = useAppSelector(state => selectKnowledgeBase(state) ? selectKnowledgeBase(state).id : null);
  useEffect(() => {
    if (needsToFetchKnowledgeBase) {
      dispatch(getKnowledgeBase());
    }
  }, [dispatch, needsToFetchKnowledgeBase]);
  if (!hasFetchedKnowledgeBases) {
    return null;
  }
  if (!defaultKnowledgeBaseId) {
    return /*#__PURE__*/_jsx(Redirect, {
      from: from || '/',
      to: "/"
    });
  }
  const updatedParams = Object.assign({
    knowledgeBaseId: defaultKnowledgeBaseId
  }, params);

  // this is so dumb
  if (updatedParams.state) {
    updatedParams.state = updatedParams.state.toLowerCase();
  }
  return /*#__PURE__*/_jsx(Redirect, {
    from: from || '/',
    to: !to ? `/${defaultKnowledgeBaseId}${search}` : `${generatePath(to, updatedParams)}${search}`
  });
};
export default RedirectToDefaultKnowledgeBase;